import { set, ref } from 'firebase/database';
import { db } from './config';
import type { LatLng } from './types';

export async function saveGeofence(
  centerId: string,
  uid: string,
  geofence: { center: LatLng; radius: number },
) {
  await set(
    ref(db, `centers/${centerId}/tracked/${uid}/config/geofence`),
    geofence,
  );
}

export async function clearGeofence(centerId: string, uid: string) {
  await set(ref(db, `centers/${centerId}/tracked/${uid}/config/geofence`), null);
}
